var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScanning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.33333C5 7.44928 5.35119 6.60143 5.97631 5.97631C6.60143 5.35119 7.44928 5 8.33333 5H15V8.33333H8.33333V15H5V8.33333ZM45 41.6667C45 42.5507 44.6488 43.3986 44.0237 44.0237C43.3986 44.6488 42.5507 45 41.6667 45H35V41.6667H41.6667V35H45V41.6667ZM8.33333 45C7.44928 45 6.60143 44.6488 5.97631 44.0237C5.35119 43.3986 5 42.5507 5 41.6667V35H8.33333V41.6667H15V45H8.33333ZM41.6667 5C42.5507 5 43.3986 5.35119 44.0237 5.97631C44.6488 6.60143 45 7.44928 45 8.33333V15H41.6667V8.33333H35V5H41.6667Z",
    fill: "#5A23D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7936 13.2656H14.3989C13.1525 13.2656 12.1328 14.2854 12.1328 15.5317V33.6604C12.1328 34.9067 13.1525 35.9264 14.3989 35.9264H34.7936C36.04 35.9264 37.0597 34.9067 37.0597 33.6604V15.5317C37.0597 14.2854 36.04 13.2656 34.7936 13.2656ZM34.7936 33.6604H14.3989V17.7978H34.7936V33.6604Z",
    fill: "#5A23D7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScanning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scanning.19b88379fdf5d1887619ae0edb745ded.svg";